export const firebaseConfig = {
    apiKey: "AIzaSyC2K5pEIuYf8TcHJBP47p9GmsDK27enhlw",
    authDomain: "volunteer--network.firebaseapp.com",
    databaseURL: "https://volunteer--network.firebaseio.com",
    projectId: "volunteer--network",
    storageBucket: "volunteer--network.appspot.com",
    messagingSenderId: "867395640821",
    appId: "1:867395640821:web:b8f76457b95d8d8f9254bc"
};